var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Card, { CardContent } from '@telia-front/card';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import List from '@telia-front/list';
const ArrowListContext = React.createContext({});
const ArrowList = (props) => {
    const { outerBordered = false, type = 'unstyled', className, iconClassName, purpose, itemsMargin = 'tiny', itemsPadding, heading, theme, backgroundColor, backgroundHover, large } = props, rest = __rest(props, ["outerBordered", "type", "className", "iconClassName", "purpose", "itemsMargin", "itemsPadding", "heading", "theme", "backgroundColor", "backgroundHover", "large"]);
    const arrowListContextValue = {
        purpose,
        iconClassName,
        theme,
        backgroundHover,
        backgroundColor,
        large,
    };
    const BEM = () => {
        const classArray = ['arrow-list'];
        if (className) {
            classArray.push(className);
        }
        if (large) {
            classArray.push('arrow-list--large');
            if (type === 'icon') {
                classArray.push('arrow-list--with-icon');
            }
            if (itemsMargin) {
                classArray.push(`arrow-list--margin-${itemsMargin}`);
            }
            if (itemsPadding) {
                classArray.push(`arrow-list--padding-${itemsPadding}`);
            }
            if (heading) {
                classArray.push('arrow-list--with-heading');
            }
        }
        if (purpose) {
            classArray.push(`arrow-list--purpose-${purpose}`);
        }
        return classArray.join(' ');
    };
    const getHeaderBackgroundColor = () => {
        switch (backgroundColor) {
            case 'beige':
                return 'background-4';
            case 'white':
                return 'primary-4';
            default:
                return 'neutral-1';
        }
    };
    return (React.createElement(ArrowListContext.Provider, { value: arrowListContextValue },
        React.createElement("div", { className: BEM() },
            heading && large && (React.createElement(Card, { background: "transparent" },
                React.createElement(Grid, null,
                    React.createElement(GridColumn, null,
                        React.createElement(CardContent, { background: getHeaderBackgroundColor(), borderRadius: { top: 'medium', bottom: 'none' } },
                            React.createElement(Heading, Object.assign({}, heading), heading.children)))))),
            React.createElement(List, Object.assign({}, rest, { outerBordered: outerBordered, type: type, bordered: true, fullWidth: true, theme: theme })))));
};
export { ArrowList as default, ArrowListContext, };
